import { atom } from 'jotai';
import {
  MessageDbInteractiveList,
  QRInteractiveReplyButtonsType,
  QuickReplyAtomTypeForTextOrMediaType,
  QuickReplyMsgType,
} from '../types/quick-reply';
import { AIFeaturePermissionResponse } from '../../../typings';

export const previewQuickReplyStateAtom = atom<boolean>(false);
export const createQuickReplySelectedTypeAtom = atom<QuickReplyMsgType>(QuickReplyMsgType.TEXT_OR_MEDIA);
export const createQuickReplyTextOrMediaAtom = atom<QuickReplyAtomTypeForTextOrMediaType>(null);
export const createQuickReplyInteractiveReplyButton = atom<QRInteractiveReplyButtonsType>({
  body: {
    text: '',
  },
  header: {
    type: 'text',
    text: '',
  },
  footer: {
    text: '',
  },
  buttons: [],
});

export const createQuickReplyInteractiveListAtom = atom<MessageDbInteractiveList>({
  body: {
    text: '',
  },
  header: {
    type: 'text',
    text: '',
  },
  button: '',
  footer: {
    text: '',
  },
  sections: [],
});

export const quickRepliesPopupVisibleAtom = atom<boolean>(false);

export const chatInputTextAtom = atom('');

export const aiFeaturePermissionAtom = atom<AIFeaturePermissionResponse | null>(null);

export const fmInputFooterPreviewTextAtom = atom<string>('');
export const fmInputHeaderTextPreviewTextAtom = atom<string>('');

export const activeFMPreviewInputAtom = atom<boolean>(false);
